// test2126
(2126 && 0);
